import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { getBannerIcon } from './util.js';
import { IconButton } from '../IconButton/IconButton.js';

const Banner = /*#__PURE__*/forwardRef(function Banner(props, ref) {
  const {
    children,
    state,
    onClose
  } = props;
  const className = cn('bg-white relative flex items-center gap-2 py-2 px-4 leading-6 shadow-md z-10', props.className);
  return createElement("div", {
    className: className,
    "data-taco": "banner",
    ref: ref
  }, getBannerIcon(state), children, onClose ? createElement(IconButton, {
    className: "ml-auto -mr-2 self-start",
    icon: "close",
    appearance: "discrete",
    onClick: onClose
  }) : null);
});

export { Banner };
//# sourceMappingURL=Banner.js.map
